<template>
    <div class="transfer-service-block-warning">
        <div class="transfer-service-block-warning__description">{{ $t('withdrawal-create.warning.transfer-service.title') }}</div>
        <button class="transfer-service-block-warning__button" type="button">
            <i class="icon i-arrow-right-short"></i>
        </button>
    </div>
</template>

<style lang="scss">
.transfer-service-block-warning {
  display: flex;
  align-items: center;
  background: #E697001A;
  border-radius: 8px;
  padding: 12px;
  gap: 12px;
  cursor: pointer;

  &__description {
    font-size: 14px;
    line-height: 120%;
    color: #CF7529;
  }

  &__button {
    width: 32px;
    height: 32px;
    background: #E69700;
    border-radius: 8px;
    cursor: pointer;
  }

  i {
    min-width: 18px;
  }

  p, a {
    @include text(14px, 400, #CF7529, 16.8px);
  }

  a {
    text-decoration: underline;
  }
}
</style>
